import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GmailInfo from './GmailInfo';
import ExtensionInfo from './ExtensionInfo';

import './ExtensionInfoContainer.css';


class ExtensionInfoContainer extends Component {
    render() {
        const { avatarId } = this.props;

        return (
            <div className="extension-info-container" id="extension-information-container">
                <div className="top-row">
                    <GmailInfo avatarId={avatarId}/>
                </div>
                <div className="bottom-row">
                    <ExtensionInfo avatarId={avatarId}/>
                </div>
            </div>
        );
    }
}

ExtensionInfoContainer.propTypes = {
    avatarId: PropTypes.string.isRequired
};

export default ExtensionInfoContainer;



// WEBPACK FOOTER //
// ./src/components/congrats_view/ExtensionInfoContainer.js